
<p-progressSpinner *ngIf="!showTable" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>
<p-table *ngIf="showTable" [value]="tableData" scrollable="true" [rows]="12" scrollHeight="100%" [paginator]="false" class="liquitics-compact-table" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:50%">Client</th>
            <th>Limit</th>
            <th>Balance</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td style="width:50%">{{row.entityName}}</td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.limit | currencyrounding:2:currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.balance | currencyrounding:2:currency:false | negativeparentheses}}</span>
            </td>
        </tr>
    </ng-template>
<!-- 
    <p-column [styleClass]="'col-entity'" field="entityName" header="Client" [sortable]="false" [style]="{'width':'50%','text-align':'center'}"></p-column>
    <p-column [styleClass]="'col-limit'" field="limit" header="Limit" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.limit | currencyrounding:2:currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-balance'" field="balance" header="Balance" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.balance | currencyrounding:2:currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column> -->
<!--Already commented-->
    <!-- <p-column [styleClass]="'col-movement'" field="movement" header="Mvmt" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.movement | currencyrounding:2:currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column> -->
</p-table>